export function getFileIcon (fileType) {
    // Map MIME types to icon names
    switch ((fileType || '').toLowerCase()) {
        case 'text/csv': // .csv
        case 'application/vnd.ms-excel': // .xls (legacy Excel)
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': // .xlsx (Excel OpenXML)
            return 'table-2';
        case 'application/json': // .json
            return 'braces';
        // Everything else (pdf, docx, txt, md, etc.)
        default:
            return 'file';
    }
}